/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type OrganizationPermission = "ADD_FOLLOWERS" | "CONTRACTOR_ADD_NOTE" | "CONTRACTOR_EDIT_DETAILS" | "CONTRACTOR_GROUP_CREATE" | "CONTRACTOR_MARK_DO_NOT_HIRE" | "CONTRACTOR_MARK_PROFILE_INACTIVE" | "CONTRACTOR_UPLOAD_SHOWCASE_FILE" | "DELIVERABLE_ADD_REVIEW_COMMENT_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_ADD_REVIEW_COMMENT_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_ASSIGN_INTERNALLY_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_ASSIGN_INTERNALLY_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_CHANGE_CURRENT_REVIEW_STEP_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_CHANGE_CURRENT_REVIEW_STEP_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_CREATE" | "DELIVERABLE_DEACTIVATE" | "DELIVERABLE_DELETE" | "DELIVERABLE_DELETE_FINAL_FILE" | "DELIVERABLE_DOWNLOAD_FINAL_FILE" | "DELIVERABLE_EDIT_DETAILS_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_EDIT_DETAILS_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_EXPOSE_REFERENCE_TO_SOLICITATION" | "DELIVERABLE_INTERNAL_MARK_CLOSED_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_INTERNAL_MARK_CLOSED_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_INTERNAL_RESET_OR_CANCEL" | "DELIVERABLE_MARK_COMPLETE_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_MARK_COMPLETE_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_MARK_READY_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_MARK_READY_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_UNLOCK_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_UNLOCK_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_UPLOAD_FINAL_FILE_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_UPLOAD_FINAL_FILE_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_UPLOAD_REFERENCE_FILE" | "DELIVERABLE_UPLOAD_REVIEW_ASSET_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_UPLOAD_REVIEW_ASSET_ASSIGNED_TO_AUTHENTICATED_USER" | "JOB_ADD_COMMENT" | "JOB_ASSIGN_RATING_TO_CLOSED" | "JOB_CLOSE_JOB" | "JOB_CREATE_WITHOUT_CONTRACT" | "JOB_EDIT_DETAILS" | "JOB_MANAGE_PAYMENT_REQUESTS" | "JOB_RESEND_CONTRACT" | "JOB_REVOKE_CONTRACT_IF_UNSIGNED_BY_FREELANCER" | "JOB_SIGN_AND_SEND_CONTRACT" | "JOB_TERMINATE_SIGNED_CONTRACT" | "JOB_UPLOAD_ASSOCIATED_FILES_OF_CONTRACT" | "ORGANIZATION_ADMIN_MANAGE_BILLING_INFO" | "ORGANIZATION_ADMIN_MANAGE_CONTRACTS_TEMPLATE" | "ORGANIZATION_ADMIN_MANAGE_CUSTOMIZATION" | "ORGANIZATION_ADMIN_MANAGE_ORGANIZATION_PROFILE" | "ORGANIZATION_ADMIN_MANAGE_STAFF_ROLE_AND_PERMISSIONS" | "ORGANIZATION_ADMIN_MANAGE_STORAGE" | "ORGANIZATION_ADMIN_RECEIVE_SYSTEM_NOTIFICATIONS" | "PRODUCT_CREATE" | "PRODUCT_DEACTIVATE" | "PRODUCT_DELETE" | "PRODUCT_EDIT_DETAILS" | "RELEASE_CREATE" | "RELEASE_DEACTIVATE" | "RELEASE_DELETE" | "RELEASE_EDIT_BUDGET" | "RELEASE_EDIT_DETAILS" | "RELEASE_VIEW_BUDGET" | "SOLICITATION_CREATE" | "SOLICITATION_DELETE_ASSIGNED_TO_AUTHENTICATED_USER" | "SOLICITATION_EDIT_DETAILS_ASSIGNED_TO_ANOTHER_USER" | "SOLICITATION_EDIT_DETAILS_ASSIGNED_TO_AUTHENTICATED_USER" | "SOLICITATION_MARK_CLOSED_ASSIGNED_TO_ANOTHER_USER" | "SOLICITATION_MARK_CLOSED_ASSIGNED_TO_AUTHENTICATED_USER" | "SOLICITATION_REASSIGN_TO_ANOTHER_STAFF_MEMBER" | "SOLICITATION_REPLY_TO_SOLICITATION_MESSAGE_ASSIGNED_TO_ANOTHER_USER" | "SOLICITATION_REPLY_TO_SOLICITATION_MESSAGE_ASSIGNED_TO_AUTHENTICATED_USER" | "SOLICITATION_REVERT_SOLICITATION_TO_ACTIVE_ASSIGNED_TO_ANOTHER_USER" | "SOLICITATION_REVERT_SOLICITATION_TO_ACTIVE_ASSIGNED_TO_AUTHENTICATED_USER" | "SOLICITATION_SEND_ASSIGNED_TO_ANOTHER_USER" | "SOLICITATION_SEND_ASSIGNED_TO_AUTHENTICATED_USER" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type RolesDetails_role$ref: FragmentReference;
declare export opaque type RolesDetails_role$fragmentType: RolesDetails_role$ref;
export type RolesDetails_role = {|
  +id: string,
  +name: string,
  +isDefault: boolean,
  +defaultPermissions: ?$ReadOnlyArray<?OrganizationPermission>,
  +extraPermissions: ?$ReadOnlyArray<?OrganizationPermission>,
  +basedOnRole: ?{|
    +name: string
  |},
  +$refType: RolesDetails_role$ref,
|};
export type RolesDetails_role$data = RolesDetails_role;
export type RolesDetails_role$key = {
  +$data?: RolesDetails_role$data,
  +$fragmentRefs: RolesDetails_role$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "RolesDetails_role",
  "type": "OrganizationRoleNode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isDefault",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "defaultPermissions",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "extraPermissions",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "basedOnRole",
      "storageKey": null,
      "args": null,
      "concreteType": "OrganizationRoleNode",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '4d981fdef9cdc2ec5633220e8eb6c769';
module.exports = node;
